<script setup>
const { data: searchPointList } = await useFetch('/api/search/point')
const { result, keyword } = useGolfPointSearch(searchPointList.value)
</script>

<template>
  <section class="golfSearch">
    <CommonSectionTitle title="ゴルフ場を名前で検索" />
    <div class="block">
      <form class="form">
        <label
          for=""
          class="search"
        >
          <input
            v-model="keyword"
            type="search"
            placeholder="ゴルフ場の名前で検索（ひらがなも可）"
            class="input"
            @keydown.enter.prevent
          >
        </label>
        <GolfSearchPointCandidate
          v-show="keyword !== ''"
          :result="result"
        />
      </form>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.golfSearch {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .block {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 10px;
    background-color: #F0F3F9;
    .form {
      padding: 1px 10px;
      border: 1px solid #C6CCDA;
      background-color: #FFF;
      position: relative;
      .search {
        display: flex;
        align-items: center;
      }
      .input {
        flex: 1;
        font-size: 14px;
        line-height: 1em;
        outline: none;
        @media screen and (min-width: 830px) {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
